
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommOrderBOMGrid extends Serenity.EntityGrid<ECommOrderBOMRow, any> {
        protected getColumnsKey() { return 'ECommerce.OrderBOM'; }
        protected getDialogType() { return ECommOrderBOMDialog; }
        protected getIdProperty() { return ECommOrderBOMRow.idProperty; }
        protected getInsertPermission() { return ECommOrderBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommOrderBOMRow.localTextPrefix; }
        protected getService() { return ECommOrderBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}